import { useQueryUser } from "../QueryProvider"

export type UserRole = "customer" | "demo" | "ops" | "admin"

export function useUserRole(): UserRole | undefined {
  const user = useQueryUser()

  // The user object is now passed directly from hub's Better Auth context
  // It should have the structure: { id, name, email, role: "admin", ... }
  if (user && typeof user === "object" && "role" in user) {
    return user.role as UserRole
  }

  return undefined
}

export function useIsAdmin(): boolean {
  const role = useUserRole()
  return role === "admin" || role === "ops"
}
